"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var travelEgg = {
    name: "travel",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["t", "r", "a", "v", "e", "l"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://i.imgur.com/7CjK3g7.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "400px";
        img.style.height = "350px";
        img.style.transition = "8s all linear";
        img.style.position = "fixed";
        img.style.left = "-400px";
        // img.style.bottom = 'calc(-50% + 300px)'
        img.style.bottom = "300px";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        // window.setTimeout(function(){
        //   img.style.left = 'calc(50% - 200px)'
        // },50)
        window.setTimeout(function () {
            img.style.left = "calc(100% + 500px)";
        }, 50);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
        }, 8000);
    },
};
exports.default = travelEgg;
